/**
 * @generated SignedSource<<0bf638449b99714453387e9e53da03d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoResponseType = "IMAGES" | "NUMBER" | "TEXT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoListHeader_todoWorkspace$data = {
  readonly id: string;
  readonly responseType: TodoResponseType | null;
  readonly todoCount: number;
  readonly todosCompletedCount: number;
  readonly " $fragmentType": "WorkspaceTodoListHeader_todoWorkspace";
};
export type WorkspaceTodoListHeader_todoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoListHeader_todoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListHeader_todoWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoListHeader_todoWorkspace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "todoCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "todosCompletedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseType",
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "fe90c2206e56f0f1e2069f72227c7329";

export default node;
